<script>
import QrcodeVue from 'qrcode.vue';

export default {
  components: { QrcodeVue },
  data() {
    return {
      card_name: '',
      url: '',
      plain_url: '',
    };
  },

  methods: {
    open(row) {
    this.card_name = row.user?.name || 'card';
    this.plain_url = `${window.location.origin}/card/${row.public_token}`;
    this.url = `${this.plain_url}?src=qr`; 
    },

    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.plain_url);
        this.$swalToast('Link copied');
      } catch (e) {
        this.$swalToast('Copy failed', 'error');
      }
    },

    download() {
      const canvas = this.$refs.qrWrap?.querySelector('canvas');
      if (!canvas) return;
      const a = document.createElement('a');
      a.href = canvas.toDataURL('image/png');
      a.download = `${this.card_name.replace(/\s+/g, '_')}_qr.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<template>
  <div class="modal fade" id="qr_modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">QR Code</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body text-center">
          <div ref="qrWrap" v-if="url">
            <qrcode-vue :value="url" :size="240" level="M" render-as="canvas" :margin="2" />
          </div>
          <div class="mt-2" style="font-size:12px; color:#64748b; word-break:break-all;">{{ plain_url }}</div>
        </div>

        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-light" @click="copyLink">
            <i class="ti ti-copy me-1"></i>Copy Link
          </button>
          <button type="button" class="btn btn-primary" @click="download">
            <i class="ti ti-download me-1"></i>Download
          </button>
        </div>
      </div>
    </div>
  </div>
</template>